export async function stageToFile(
    stage: any,
    options?: {
        filename?: string;
        pixelRatio?: number;
        transformer?: any | null;
    },
): Promise<File> {
    const { filename = 'result.png', pixelRatio = 2, transformer } = options ?? {};

    if (!stage) {
        throw new Error('Stage is missing');
    }

    // Hide UI helpers (Transformer, guides, etc.)
    transformer?.hide();
    stage.batchDraw();

    // 1) Stage → dataURL
    const dataUrl: string = stage.toDataURL({ pixelRatio });

    // Restore UI helpers
    transformer?.show();
    stage.batchDraw();

    // 2) dataURL → Blob
    const blob = await (await fetch(dataUrl)).blob();

    // 3) Blob → File (IMPORTANT: image/png)
    return new File([blob], filename, { type: 'image/png' });
}
